<template>
    <div class="wrap wrap--last">
        <SectionTitle text="Brand" class="title" />

        <ul class="brandList" v-show="$store.state.switchTab.brand">
            <li v-for="(item, index) in brandList" :key="'ranking' + index">
                <a :href="item[$store.state.hostName]">
                    <img :src="item.imageURL" alt="">
                </a>
            </li>
        </ul>

        <MoreLink to="/brands" text="ALL" />
    </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle.vue'
import MoreLink from '@/components/MoreLink.vue'

// style の 6列 / 10列 の境界（max-width: 963px）と合わせること
const NARROW_MAX_WIDTH = 963
const NARROW_QUERY = `(max-width: ${NARROW_MAX_WIDTH}px)`

export default {
  name: 'Brand',

  components: {
    SectionTitle,
    MoreLink
  },

  data () {
    return {
      // 初回描画から正しい件数にするため、mounted を待たずに判定する
      isNarrow: typeof window !== 'undefined' && window.matchMedia(NARROW_QUERY).matches
    }
  },

  computed: {
    // NARROW_MAX_WIDTH 以下（4列・6列）は列数で割り切れる 72 件、それ以上（10列）は 70 件
    brandList () {
      return this.$store.state.json.brand.slice(0, this.isNarrow ? 72 : 70)
    }
  },

  mounted () {
    this.mediaQuery = window.matchMedia(NARROW_QUERY)
    this.isNarrow = this.mediaQuery.matches
    this.mediaQuery.addEventListener('change', this.onMediaChange)
  },

  beforeDestroy () {
    this.mediaQuery.removeEventListener('change', this.onMediaChange)
  },

  methods: {
    onMediaChange (e) {
      this.isNarrow = e.matches
    }
  }
}
</script>

<style lang="scss" scoped>
.brandList {
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    border-top: 1px solid #dddddd;
    border-left: 1px solid #dddddd;

    @media screen and (max-width: 722px) {
        grid-template-columns: repeat(4, 1fr);
    }

    @media screen and (min-width: 723px) and (max-width: 963px) {
        grid-template-columns: repeat(6, 1fr);
    }

    @media screen and (min-width: 964px) and (max-width: 1523px) {
        grid-template-columns: repeat(10, 1fr);
    }

    @media screen and (min-width: 1524px) and (max-width: 2286px) {
        grid-template-columns: repeat(10, 1fr);
    }

    @media screen and (min-width: 2287px) {
        grid-template-columns: repeat(10, 1fr);
    }

    >li {
        align-content: center;
        aspect-ratio: 1 / 1;
        padding: 10px;
        text-align: center;
        border-right: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;

        a {
            position: relative;
            display: block;

            &:hover {
                opacity: .5;
                transition: .2s;
            }
        }
    }

    img {
        width: 60%;
    }
}
</style>
